var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCargoShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.98 511.98",
    style: {
      enableBackground: "new 0 0 511.98 511.98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 145,
    rx: 3,
    ry: 3,
    width: 8,
    height: 40,
    style: {
      fill: "#434A54",
      stroke: "black",
      strokeWidth: 5,
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M138.657,309.327h-64c-5.891,0-10.656-4.779-10.656-10.654V170.658 c0-5.89,4.766-10.671,10.656-10.671h63.999c5.89,0,10.671,4.781,10.671,10.671v128.014 C149.328,304.548,144.547,309.327,138.657,309.327z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 181.319,
    style: {
      fill: "#5D9CEC"
    },
    width: 85.33,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 213.309,
    style: {
      fill: "#CCD1D9"
    },
    width: 21.328,
    height: 85.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 187,
    style: {
      fill: "#434A54",
      opacity: 0.5
    },
    width: 73,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M511.141,273.173c-1.656-3.945-5.531-6.508-9.828-6.508h-106.67c-1.656,0-3.28,0.375-4.765,1.125 l-40.406,20.195H10.659c-3.922,0-7.547,2.188-9.406,5.656c-1.844,3.438-1.641,7.656,0.531,10.938l42.671,63.998 c1.984,2.969,5.312,4.75,8.875,4.75h364.562c2.875,0,5.625-1.156,7.625-3.219l83.421-85.342 C511.938,281.704,512.813,277.141,511.141,273.173z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M103.532,323.108c4.172,4.156,4.172,10.938,0,15.094c-4.156,4.156-10.906,4.156-15.078,0 c-4.172-4.156-4.172-10.938,0-15.094C92.626,318.952,99.376,318.952,103.532,323.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M167.531,323.108c4.172,4.156,4.172,10.938,0,15.094c-4.156,4.156-10.906,4.156-15.078,0 s-4.172-10.938,0-15.094S163.375,318.952,167.531,323.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M231.53,323.108c4.172,4.156,4.172,10.938,0,15.094c-4.156,4.156-10.906,4.156-15.078,0 c-4.171-4.156-4.171-10.938,0-15.094C220.623,318.952,227.373,318.952,231.53,323.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M295.52,323.108c4.172,4.156,4.172,10.938,0,15.094c-4.156,4.156-10.905,4.156-15.077,0 s-4.172-10.938,0-15.094S291.364,318.952,295.52,323.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M359.519,323.108c4.172,4.156,4.172,10.938,0,15.094c-4.156,4.156-10.906,4.156-15.078,0 s-4.172-10.938,0-15.094S355.363,318.952,359.519,323.108z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 290,
    r: 10,
    fill: "#434A54"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 445,
    cy: 290,
    r: 10,
    fill: "#434A54"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoShip);
export default __webpack_public_path__ + "static/media/cargo-ship.161b22dcc68edd439cdc2e3cfc0d053b.svg";
export { ForwardRef as ReactComponent };